export const DAYS_TO_BOOK = 3 // Used to display urgency tag
export const NUMBER_OF_DATE_CHANGES_ALLOWED = 3

export const enum SALES_ENVIRONMENT_ENUM {
  hotelOnly = 'hotel_only',
  hotelPackage = 'hotel_package'
}

export const GOOGLE_ADS_UTM_CONTENT = 'gha-lpp'
